import React from "react";
import { useTranslation } from "react-i18next";
import { secondaryCriteria, SecondaryCriteriaType } from "@planzone/dto";

import { SecondaryCriteriaIcon } from "@common/secondaryCriteriaIcon";

import { Props } from "./types";
import styles from "./styles.scss";

const criteriaTypes: SecondaryCriteriaType[] = [
  "number",
  "text",
  "richText",
  "date",
  "list",
  "document",
  "link",
  "resource",
];

function SecondaryCriteriaTemplatePlaceholder({ add }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.placeholder}>
      <div className={styles.header}>
        <p className={styles.title}>
          {t("common.secondaryCriteriaTemplatePlaceholder.title")}
        </p>
        <p className={styles.message}>
          {t("common.secondaryCriteriaTemplatePlaceholder.message")}
        </p>
      </div>
      <ul className={styles.list}>
        {criteriaTypes.map((criteriaType) => (
          <li
            key={criteriaType}
            className={styles.criteria}
            onClick={() =>
              add({
                ...secondaryCriteria,
                type: criteriaType,
                uuid: "",
                hasChanged: true,
                accessRoles: {
                  read: [
                    "pz_admin",
                    "pz_under_admin",
                    "pz_user",
                    "pz_visitor",
                    "pr_manager",
                    "pr_worker",
                    "pr_visitor",
                  ],
                  write: [
                    "pz_admin",
                    "pz_under_admin",
                    "pz_user",
                    "pr_manager",
                    "pr_worker",
                  ],
                },
              })
            }
          >
            <SecondaryCriteriaIcon
              type={criteriaType}
              className={styles.icon}
            />
            <p className={styles.name}>
              {t(`secondaryCriteriaTemplate.form.type.types.${criteriaType}`)}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
}

export { SecondaryCriteriaTemplatePlaceholder };
